module.exports = __webpack_public_path__ + "img/item_Story_30.42ee2e12.jpeg";